/**
 * L2-R5: moved to @miq/shared-models (helpers/records.helpers.ts). This shim keeps the old
 * import path working; new code should import from '@miq/shared-models'.
 */
/*
 * Two groups did NOT move into @miq/shared-models:
 *  - `simpleValueValidation` / `isDash` / `multipleSimpleValueValidation` already existed
 *    verbatim in @miq/utils (lib/core-utils/validators.ts), so they come from there.
 *  - `ColumnSimpleKeys`, `updateColumnByField` and the aliased
 *    `findColumnBy`/`findColumnByField` come straight from the lib's catalog.helpers, whose
 *    own `findColumnBy` is a different function - hence the explicit aliasing here.
 */
export type { ColumnSimpleKeys } from '@miq/shared-models';
export { findColumnInSectionsBy as findColumnBy, findColumnInSectionsByField as findColumnByField, updateColumnByField } from '@miq/shared-models';
export { isARecordOutdated, updateSingleClibpoardReportItemRecord, validateUomFields, isValuesAndUomsAreSetUp, getUOM, flatObject, getEntityId, handleDownloadError, displayCompanyName, complexDisplayCompanyFn, getFirstAvailableContact } from '@miq/shared-models';
export { simpleValueValidation, isDash, multipleSimpleValueValidation } from '@miq/utils';
